module.exports = __webpack_public_path__ + "img/photo-2-1.f139e8c9.webp";